import styled from "styled-components";
import { Link } from "react-router-dom";

export const NavContainer = styled.nav`
  background: ${(props) => props.theme.colors.primary};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  transition: all 0.3s ease;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 0.5rem 0;
  }
`;

export const Logo = styled(Link)`
  font-size: 1.3rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.text.light} !important;
  text-decoration: none;
  transition: transform 0.3s ease;
  padding: 0.5rem 0;

  &:hover {
    transform: scale(1.05);
    color: #f8f9fa !important;
    cursor: pointer;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 1.1rem;
    margin-right: 0;
  }
`;

export const StyledLogoWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin: 0;
  flex-direction: row;
  font-size: 16px;
  @media (max-width: 375px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const StyledLogoName = styled.div`
  margin: 0;
`;
export const StyledLogoTitle = styled.div`
  margin: 0;
`;

// Regular NavLink for section scrolling
export const NavLink = styled.a`
  font-weight: 500;
  margin: 0 0.5rem;
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.colors.text.light} !important;
    transform: translateY(-2px);
  }

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 50%;
    background: ${(props) => props.theme.colors.text.light};
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover::after {
    width: 100%;
  }
`;

// Special styling for Router Link components
export const RouterNavLink = styled(Link)`
  font-weight: 500;
  margin: 0 0.5rem;
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease;
  position: relative;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.colors.text.light} !important;
    transform: translateY(-2px);
  }

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 50%;
    background: ${(props) => props.theme.colors.text.light};
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover::after {
    width: 100%;
  }
`;

export const LanguageButton = styled.button`
  border: 2px solid ${(props) => props.theme.colors.text.light} !important;
  color: ${(props) => props.theme.colors.background} !important;
  font-weight: bold;
  transition: all 0.3s ease;
  padding: 9px 11px;
  border-radius: 60px;

  &:hover {
    background: ${(props) => props.theme.colors.text.light} !important;
    color: ${(props) => props.theme.colors.primary} !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PianoKey = styled.span`
  display: block;
  width: 30px;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
  position: relative;

  /* Piano key effect with subtle shadows */
  /* box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.3),
    inset 0 -1px 1px rgba(0, 0, 0, 0.2); */

  &:nth-child(1) {
    transform-origin: center;
  }

  &:nth-child(2) {
    width: 25px;
    background: #f8f9fa;
  }

  &:nth-child(3) {
    width: 28px;
    transform-origin: center;
  }

  /* Add subtle bevel effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 2px;
    /* background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.4) 100%
    ); */
    pointer-events: none;
  }
`;

// Piano Toggler - Add this at the end
export const PianoToggler = styled.button`
  border: 0 !important;
  border-radius: 8px !important;
  padding: 12px 8px !important;
  background: transparent !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50px;
  height: 40px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  gap: 2px;

  &:hover {
    border-color: white !important;
    /* background: linear-gradient(135deg, #3d566e 0%, #34495e 100%) !important; */
    transform: scale(1.05);
  }

  &:focus {
    box-shadow: none !important;
  }

  &[aria-expanded="true"] {
    background: transparent !important;

    ${PianoKey}:nth-child(1) {
      transform: rotate(45deg) translate(4px, 6px);
      background: white;
    }

    ${PianoKey}:nth-child(2) {
      opacity: 0;
      transform: translateX(-10px);
    }

    ${PianoKey}:nth-child(3) {
      transform: rotate(-45deg) translate(4px, -6px);
      background: white;
    }
  }
`;
